<div *ngIf="isAddressAvailable" class="name-with-address">
    <!-- <span [ngClass]="{'text-primary-color':true}">{{params?.value}}</span><br> -->
    <p class="my-0 mx-2 d-flex flex-column">
        <span (click)="onClick($event)" (contextmenu)="onContextMenu($event)"
            [ngClass]="{'text-primary-color':textPrimary,'cursor-pointer': isCursor}">{{name}}</span>
        <span class="address text-truncate" [title]="params?.data?.addressLine1"
            *ngIf="params?.data?.addressLine1">{{params?.data?.addressLine1}}</span>
    </p>
</div>
<div class="d-flex align-items-center">
    <div class="d-grid ps-2 font-11" *ngIf="!isAddressAvailable" (click)="onClick($event)" (contextmenu)="onContextMenu($event)"
        [ngClass]="{'text-primary-color':textPrimary,'cursor-pointer': isCursor}">
        <span class="text-truncate">{{name}}</span>
        </div>
    <div class="d-flex cursor-pointer" (click)="onCrossIconClicked(params)" *ngIf="params?.isCrossIcon && params?.data?.billSeries">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="black" viewBox="0 0 16 16">
            <path
                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
    </div>
<!-- <span class="ps-2 font-13" *ngIf="!isAddressAvailable && !params?.showDetails" (click)="onClick($event)" [ngClass]="{'text-primary-color':textPrimary,'cursor-pointer': isCursor}">{{name}}</span> -->

<!-- <div *ngIf="params?.showDetails" class="name-with-address"> -->
    <!-- <span [ngClass]="{'text-primary-color':true}">{{params?.value}}</span><br> -->
    <!-- <p class="p-0 my-0 mx-2 w-100"><span class="details-class text-truncate" (click)="onClick($event)" [ngClass]="{'text-primary-color':textPrimary,'cursor-pointer': isCursor}">{{name}}</span><br *ngIf="details.text"><span class="details-class text-truncate" [title]="details?.text" *ngIf="details.text">{{details.text}}</span></p> -->
</div>